import { api } from '@/core/api/';

const URL = 'api/closinganalysisapi';
const header = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

export const getClosingAnalysisByIdRequest = (requestId) =>
  api.get(`${URL}/${requestId}`);

export const saveClosingAnalysis = (payload) => api.post(`${URL}`, payload);

export const submitClosingAnalysis = (payload) =>
  api.post(`${URL}/submit`, payload);

export const savedDocuments = (payload) => {
  return api.post(`${URL}/uploadDocument/`, payload, header);
};

export const removeDocument = (guid) => {
  return api.delete(`${URL}/removeDocument/${guid}`, header);
};
